import { useLocation, useNavigate } from "react-router-dom";
import MainContainer from "../../layout/MainContainer";
import DownloadIcon from "@mui/icons-material/Download";
import { Box, Button, Tab, Tabs } from "@mui/material";
import SearchBar from "../../components/SearchBar";
import React, { useEffect, useState } from "react";
import MetricCard from "../dashboard/MetricCard";
import { formatAEDNumber, isValidInput } from "../../utils/validations";
import {
  useBookingReportsMutation,
  useCancellationReportsMutation,
  useExportBookingReportsMutation,
  useExportMemberReportsMutation,
  useMemberReportsMutation,
} from "../../service/reports";
import { showError, showToast } from "../../constants/toasts";
import dayjs, { Dayjs } from "dayjs";
import { BookingReport, Categories, MemberReport } from "../../types/General";
import CustomPagination from "../../components/CustomPagination";
import Loader from "../../constants/Loader";
import { formatDubaiDateTime } from "../../utils/dateTime";
import MemberFilter from "../../components/MemberFilter";
import { USER_STATUS } from "../../utils/enums";
import BookingFilters from "../../components/BookingFilters";
import {
  useLazyGetDietaryQuery,
  useLazyGetExpertiseQuery,
  useLazyGetInterestQuery,
} from "../../service/cms";
import { useLazyAllMembersQuery } from "../../service/user";
import {
  useLazyGetCategoryQuery,
  useLazyGetInternalProcessQuery,
} from "../../service/category";
import { useLazyAllEmployeesQuery } from "../../service/booking";
import { useAppDispatch, useAppSelector } from "../../hooks/store";
import { RootState } from "../../app/store";
import {
  resetMemberFilters,
  setMemberFilters,
} from "../../reducers/memberFiltersSlice";
import {
  resetBookingFilters,
  setBookingFilters,
} from "../../reducers/bookingFiltersSlice";
interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

interface EmployeeType {
  email: string;
  id: string;
  name: string;
}

interface Status {
  id: string;
  name: string;
  isDeletable: boolean;
  createAt: string; // ISO date string
  updateAt: string; // ISO date string
  isActive: boolean;
}

enum TREND {
  INCREASE = "Increase",
  DECREASE = "Decrease",
}

interface Interests {
  created: string;
  id: number;
  isActive: boolean;
  name: string;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
const ManageAnalytics = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { state } = location;
  const type = state?.type;
  const dispatch = useAppDispatch();
  const memberFilters = useAppSelector(
    (state: RootState) => state.memberFilters
  );
  const bookingFilters = useAppSelector(
    (state: RootState) => state.bookingFilters
  );

  const [memberReports] = useMemberReportsMutation();
  const [bookingReports] = useBookingReportsMutation();
  const [cancellationReports] = useCancellationReportsMutation();
  const [getInterest] = useLazyGetInterestQuery();
  const [getExpertise] = useLazyGetExpertiseQuery();
  const [getDietary] = useLazyGetDietaryQuery();
  const [getUsers] = useLazyAllMembersQuery();
  const [getCategory] = useLazyGetCategoryQuery();
  const [getInternalProcess] = useLazyGetInternalProcessQuery();
  const [employees] = useLazyAllEmployeesQuery();
  const [exportMemberReports] = useExportMemberReportsMutation();
  const [exportBookingReports] = useExportBookingReportsMutation();

  const [valueTabs, setValueTabs] = React.useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const [memberData, setMemberData] = useState<MemberReport[]>([]);
  const [bookingData, setBookingData] = useState<BookingReport[]>([]);
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState<string>("");
  const [page, setPage] = useState(1);
  const [count, setCount] = useState(10);

  const [loading, setLoading] = useState(false);
  const [totalAmount, setTotalAmount] = useState<number>(0);
  const [percentChange, setPercentChange] = useState<number>(0);
  const [trend, setTrend] = useState<string>("");
  const [cancellationData, setCancellationData] = useState<any[]>([]);
  const [interests, setInterests] = useState<Interests[]>([]);
  const [expertise, setExpertise] = useState([]);
  const [dietary, setDietary] = useState([]);
  const [users, setUsers] = useState([]);
  const [categoryData, setCategoryData] = useState<Categories[]>([]);
  const [internalData, setInternalData] = useState<Status[]>([]);
  const [employeeData, setEmployeeData] = useState<EmployeeType[]>([]);

  const handleFilterChange = (key: string, value: any) => {
    dispatch(setMemberFilters({ [key]: value }));
  };

  const handleClearAll = () => {
    dispatch(resetMemberFilters());
  };

  const handleFilterChangeBooking = (key: string, value: any) => {
    dispatch(setBookingFilters({ [key]: value }));
  };

  const handleClearAllBookingFilter = () => {
    dispatch(resetBookingFilters());
  };

  const getMemberReports = async (
    clearData?: any,
    newSignupMembers?: boolean,
    activeMembers?: number,
    expiringTrials?: boolean,
    upcomingRenewals?: boolean
  ) => {
    if (clearData) {
      setPage(1);
    }

    const body: Record<string, any> = {
      search: debouncedSearchTerm.trim(),
      pageNumber: page,
      pageSize: 10,
      ActiveMembers: memberFilters.activeMembers,
      ...((memberFilters.activeMembersDays || activeMembers) && !clearData
        ? { activeMemberdays: activeMembers ? activeMembers : 30 }
        : {}),
      ...(memberFilters.gender
        ? { gender: clearData ? null : memberFilters.gender }
        : {}),
      ...(memberFilters.membershipType
        ? { membershipType: clearData ? null : memberFilters.membershipType }
        : {}),
      ...((memberFilters.membership || expiringTrials || upcomingRenewals) &&
      !clearData
        ? {
            membership: expiringTrials
              ? "Trial"
              : upcomingRenewals
                ? "Paid"
                : memberFilters.membership,
          }
        : {}),
      ...(memberFilters.isNewMember
        ? { isNewMember: memberFilters.isNewMember }
        : {}),
      ...(memberFilters.startDate
        ? {
            startDate: clearData
              ? null
              : dayjs(memberFilters.startDate).format("YYYY-MM-DDTHH:mm:ss"),
          }
        : {}),
      ...(memberFilters.endDate
        ? {
            endDate: clearData
              ? null
              : dayjs(memberFilters.endDate).format("YYYY-MM-DDTHH:mm:ss"),
          }
        : {}),
      ...(memberFilters.minAge
        ? { minAge: clearData ? null : memberFilters.minAge }
        : {}),
      ...(memberFilters.maxAge
        ? { maxAge: clearData ? null : memberFilters.maxAge }
        : {}),
      ...(memberFilters.expertise
        ? { expertise: clearData ? null : memberFilters.expertise }
        : {}),
      ...(memberFilters.dietary
        ? { dietary: clearData ? null : memberFilters.dietary }
        : {}),
      ...(memberFilters.interests
        ? { interests: clearData ? null : memberFilters.interests }
        : {}),
      ...(memberFilters.subscriptionType
        ? {
            subscriptionType: clearData ? null : memberFilters.subscriptionType,
          }
        : {}),
      ...(memberFilters.subscriptionStartDate
        ? {
            subscriptionStartDate: clearData
              ? null
              : dayjs(memberFilters.subscriptionStartDate).format(
                  "YYYY-MM-DDTHH:mm:ss"
                ),
          }
        : {}),
      ...(memberFilters.expiryDate
        ? {
            expiryDate: clearData
              ? null
              : dayjs(memberFilters.expiryDate).format("YYYY-MM-DDTHH:mm:ss"),
          }
        : {}),
      ...(memberFilters.onlyLoggedIn
        ? { onlyLoggedIn: clearData ? false : memberFilters.onlyLoggedIn }
        : {}),
      ...(memberFilters.notCreatedOrder
        ? { notCreatedOrder: clearData ? false : memberFilters.notCreatedOrder }
        : {}),
      ...((memberFilters.expiringInDays ||
        expiringTrials ||
        upcomingRenewals) &&
      !clearData
        ? {
            expiringInDays:
              expiringTrials || upcomingRenewals
                ? expiringTrials
                : memberFilters.expiringInDays,
          }
        : {}),
      ...((memberFilters.newSignupMembers || newSignupMembers) && !clearData
        ? {
            newSignupMembers: newSignupMembers
              ? newSignupMembers
              : memberFilters.newSignupMembers,
          }
        : {}),
      ...(memberFilters.inactiveMembers && !clearData
        ? { inactiveMembers: memberFilters.inactiveMembers }
        : {}),
    };

    try {
      setLoading(true);
      const response = await memberReports(body).unwrap();
      setLoading(false);
      if (response.status === 200) {
        setMemberData(response?.data?.records || []);
        setCount(response?.data?.totalRecords || 0);
      } else {
        setMemberData([]);
      }
    } catch (error: any) {
      setLoading(false);
      showToast(error?.data?.message || "");
    }
  };

  const exportMemberReportsApi = async (
    clearData?: any,
    newSignupMembers?: boolean,
    activeMembers?: number,
    expiringTrials?: boolean,
    upcomingRenewals?: boolean
  ) => {
    if (clearData) {
      setPage(1);
    }
    const body: Record<string, any> = {
      search: debouncedSearchTerm.trim(),
      pageNumber: 1,
      pageSize: 100,
      ActiveMembers: memberFilters.activeMembers,
      ...((memberFilters.activeMembersDays || activeMembers) && !clearData
        ? { activeMemberdays: activeMembers ? activeMembers : 30 }
        : {}),
      ...(memberFilters.gender
        ? { gender: clearData ? null : memberFilters.gender }
        : {}),
      ...(memberFilters.membershipType
        ? { membershipType: clearData ? null : memberFilters.membershipType }
        : {}),
      ...((memberFilters.membership || expiringTrials || upcomingRenewals) &&
      !clearData
        ? {
            membership: expiringTrials
              ? "Trial"
              : upcomingRenewals
                ? "Paid"
                : memberFilters.membership,
          }
        : {}),
      ...(memberFilters.isNewMember
        ? { isNewMember: memberFilters.isNewMember }
        : {}),
      ...(memberFilters.startDate
        ? {
            startDate: clearData
              ? null
              : memberFilters.startDate?.toISOString(),
          }
        : {}),
      ...(memberFilters.endDate
        ? { endDate: clearData ? null : memberFilters.endDate?.toISOString() }
        : {}),
      ...(memberFilters.minAge
        ? { minAge: clearData ? null : memberFilters.minAge }
        : {}),
      ...(memberFilters.maxAge
        ? { maxAge: clearData ? null : memberFilters.maxAge }
        : {}),
      ...(memberFilters.expertise
        ? { expertise: clearData ? null : memberFilters.expertise }
        : {}),
      ...(memberFilters.dietary
        ? { dietary: clearData ? null : memberFilters.dietary }
        : {}),
      ...(memberFilters.interests
        ? { interests: clearData ? null : memberFilters.interests }
        : {}),
      ...(memberFilters.subscriptionType
        ? {
            subscriptionType: clearData ? null : memberFilters.subscriptionType,
          }
        : {}),
      ...(memberFilters.subscriptionStartDate
        ? {
            subscriptionStartDate: clearData
              ? null
              : memberFilters.subscriptionStartDate?.toISOString(),
          }
        : {}),
      ...(memberFilters.expiryDate
        ? {
            expiryDate: clearData
              ? null
              : memberFilters.expiryDate?.toISOString(),
          }
        : {}),
      ...(memberFilters.onlyLoggedIn
        ? { onlyLoggedIn: clearData ? false : memberFilters.onlyLoggedIn }
        : {}),
      ...(memberFilters.notCreatedOrder
        ? { notCreatedOrder: clearData ? false : memberFilters.notCreatedOrder }
        : {}),
      ...((memberFilters.expiringInDays ||
        expiringTrials ||
        upcomingRenewals) &&
      !clearData
        ? {
            expiringInDays:
              expiringTrials || upcomingRenewals
                ? expiringTrials
                : memberFilters.expiringInDays,
          }
        : {}),
      ...((memberFilters.newSignupMembers || newSignupMembers) && !clearData
        ? {
            newSignupMembers: newSignupMembers
              ? newSignupMembers
              : memberFilters.newSignupMembers,
          }
        : {}),
      ...(memberFilters.inactiveMembers && !clearData
        ? { inactiveMembers: memberFilters.inactiveMembers }
        : {}),
    };

    try {
      setLoading(true);
      const response: any = await exportMemberReports({
        format: "excel",
        body,
      }).unwrap();
      setLoading(false);
      if (response.statusCode === 200) {
        window.open(response?.downloadUrl, "_blank");
      } else {
        showError(response?.message || "");
      }
    } catch (error: any) {
      setLoading(false);
      showError(error?.data?.message || "");
    }
  };

  const getBookingReports = async (clearAll?: any) => {
    const body: Record<string, any> = {
      search: debouncedSearchTerm.trim(),
      pageNumber: page,
      pageSize: 10,
      // bookingDateFrom: "2025-10-15T11:29:59.911Z",
      // paymentStatus: "string",
      // topOffer: true,
      // sortColumn: "string",
      // sortOrder: "string"

      ...(bookingFilters.startRange && !clearAll
        ? {
            startRange: dayjs(bookingFilters.startRange).format(
              "YYYY-MM-DDTHH:mm:ss"
            ),
          }
        : {}),
      ...(bookingFilters.endRange && !clearAll
        ? {
            endRange: dayjs(bookingFilters.endRange).format(
              "YYYY-MM-DDTHH:mm:ss"
            ),
          }
        : {}),
      ...(bookingFilters.bookingDateFrom && !clearAll
        ? {
            bookingDateFrom: dayjs(bookingFilters.bookingDateFrom).format(
              "YYYY-MM-DDTHH:mm:ss"
            ),
          }
        : {}),
      ...(bookingFilters.userId && !clearAll
        ? { userId: bookingFilters.userId }
        : {}),
      ...(bookingFilters.memberShipType && !clearAll
        ? { memberShipType: bookingFilters.memberShipType }
        : {}),
      ...(bookingFilters.categoryId && !clearAll
        ? { categoryId: bookingFilters.categoryId }
        : {}),
      ...(bookingFilters.bookingStatus && !clearAll
        ? { bookingStatus: bookingFilters.bookingStatus }
        : {}),
      ...(bookingFilters.employeeId && !clearAll
        ? { employeeId: bookingFilters.employeeId }
        : {}),
      ...(bookingFilters.numberofGuest && !clearAll
        ? { numberofGuest: bookingFilters.numberofGuest }
        : {}),
      ...(bookingFilters.bookingNumberofDays && !clearAll
        ? { bookingNumberofDays: 30 }
        : {}),
      ...(bookingFilters.isTodayBooking && !clearAll
        ? { isTodayBooking: bookingFilters.isTodayBooking }
        : {}),
    };

    try {
      setLoading(true);
      const response = await bookingReports(body).unwrap();
      setLoading(false);
      if (response.status === 200) {
        setBookingData(response?.data?.bookingReports || []);
        setCount(response?.data?.totalCount || 0);
        setTotalAmount(response?.data?.overallTotal || 0);
        setPercentChange(response?.data?.percentageChange || 0);
        setTrend(response?.data?.trend || "");
      } else {
        setBookingData([]);
      }
    } catch (error: any) {
      setLoading(false);
      showToast(error?.data?.message || "");
    }
  };

  const exportBookingReportsApi = async (clearAll?: any) => {
    if (clearAll) {
      setPage(1);
    }
    const body: Record<string, any> = {
      search: debouncedSearchTerm.trim(),
      pageNumber: page,
      pageSize: 10,
      ...(bookingFilters.startRange && !clearAll
        ? { startRange: bookingFilters.startRange?.toISOString() }
        : {}),
      ...(bookingFilters.endRange && !clearAll
        ? { endRange: bookingFilters.endRange?.toISOString() }
        : {}),
      ...(bookingFilters.bookingDateFrom && !clearAll
        ? { bookingDateFrom: bookingFilters.bookingDateFrom?.toISOString() }
        : {}),
      ...(bookingFilters.userId && !clearAll
        ? { userId: bookingFilters.userId }
        : {}),
      ...(bookingFilters.memberShipType && !clearAll
        ? { memberShipType: bookingFilters.memberShipType }
        : {}),
      ...(bookingFilters.categoryId && !clearAll
        ? { categoryId: bookingFilters.categoryId }
        : {}),
      ...(bookingFilters.bookingStatus && !clearAll
        ? { bookingStatus: bookingFilters.bookingStatus }
        : {}),
      ...(bookingFilters.employeeId && !clearAll
        ? { employeeId: bookingFilters.employeeId }
        : {}),
      ...(bookingFilters.numberofGuest && !clearAll
        ? { numberofGuest: bookingFilters.numberofGuest }
        : {}),
      ...(bookingFilters.bookingNumberofDays && !clearAll
        ? { bookingNumberofDays: 30 }
        : {}),
      ...(bookingFilters.isTodayBooking && !clearAll
        ? { isTodayBooking: bookingFilters.isTodayBooking }
        : {}),
    };

    try {
      setLoading(true);
      const response: any = await exportBookingReports({
        format: "excel",
        body,
      }).unwrap();
      setLoading(false);
      if (response.statusCode === 200) {
        window.open(response?.downloadUrl, "_blank");
      } else {
        showError(response?.message || "");
      }
    } catch (error: any) {
      setLoading(false);
      showError(error?.data?.message || "");
    }
  };

  const getCancellationReports = async () => {
    const body: Record<string, any> = {
      search: debouncedSearchTerm.trim(),
      pageNumber: page,
      pageSize: 10,
    };

    try {
      setLoading(true);
      const response = await cancellationReports(body).unwrap();
      setLoading(false);
      if (response.status === 200) {
        // setCancellationData(response?.data?.bookingReports || []);
        setCount(response?.data?.totalCount || 0);
      } else {
        setCancellationData([]);
      }
    } catch (error: any) {
      setLoading(false);
      showToast(error?.data?.message || "");
    }
  };

  const rows1 = [
    {
      bookingId: "1",
      name: "John Smith",
      phone: "+971 (0) 567894623",
      offerName: "The Residence Tunis",
      bookingTime: "2nd-June-2025 | 6:00PM",
      guests: "04",
      category: "Dining",
      employeeName: "John Smith",
      internalStatus: "New",
      avatar: "/static/images/user_placeholder.png",
      reason:
        "Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptate, quia!",
      amount: "AED 5000",
    },
    {
      bookingId: "5",
      name: "Ethan Hunt",
      phone: "+971 (0) 567894614",
      offerName: "Wedding Event",
      bookingTime: "6th-June-2025 | 5:00PM",
      guests: "10",
      category: "Event",
      employeeName: "Steve Rogers",
      internalStatus: "New",
      avatar: "/static/images/user_placeholder.png",
      reason:
        "Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptate, quia!",
      amount: "AED 3500",
    },
    {
      bookingId: "9",
      name: "Chandler Bing",
      phone: "+971 (0) 567894618",
      offerName: "Desert Safari",
      bookingTime: "10th-June-2025 | 4:00PM",
      guests: "0",
      category: "Experience",
      employeeName: "Natasha Romanoff",
      internalStatus: "New",
      avatar: "/static/images/user_placeholder.png",
      reason:
        "Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptate, quia!",
      amount: "AED 2000",
    },
  ];

  const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
    setPage(1);
    setValueTabs(newValue);
  };

  const getInterestApi: any = async () => {
    setLoading(true);
    try {
      const response = await getInterest({
        page: 1,
        search: "",
      }).unwrap();
      if (response?.status === 200) {
        setLoading(false);
        setInterests(response?.data || []);
        // setCount(response?.data?.totalCount || 0);
      } else {
        setLoading(false);
        setInterests([]);
      }
    } catch (error: any) {
      setLoading(false);
      showError(error?.data?.message || "");
    }
  };

  const getExpertiseApi: any = async () => {
    setLoading(true);
    try {
      const response = await getExpertise({
        page: 1,
        search: "",
      }).unwrap();
      if (response?.status === 200) {
        setLoading(false);
        setExpertise(response?.data?.items || []);
      } else {
        setLoading(false);
        setInterests([]);
      }
    } catch (error: any) {
      setLoading(false);
      showError(error?.data?.message || "");
    }
  };

  const getDietaryApi: any = async () => {
    setLoading(true);
    try {
      const response = await getDietary({
        page: 1,
        search: "",
      }).unwrap();
      if (response?.status === 200) {
        setLoading(false);
        setDietary(response?.data || []);
      } else {
        setLoading(false);
        setInterests([]);
      }
    } catch (error: any) {
      setLoading(false);
      showError(error?.data?.message || "");
    }
  };

  const getUsersApi = async () => {
    setLoading(true);
    try {
      const response = await getUsers({
        search: "",
      }).unwrap();

      setLoading(false);

      if (response.status === 200) {
        setUsers(response?.data || []);
      } else {
        setUsers([]);
      }
    } catch (error: any) {
      setLoading(false);
      showError(error?.data?.message || "");
    }
  };

  const getCategoryApi = async () => {
    try {
      const response = await getCategory({ search: "" }).unwrap();
      if (response.status === 200) {
        setCategoryData(response?.data || []);
        // setCount(response?.data?.totalCount);
      } else {
        setCategoryData([]);
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
    }
  };

  const getInternalProcessApi = async () => {
    try {
      const response = await getInternalProcess({
        search: "",
      }).unwrap();
      if (response.status === 200) {
        setInternalData(response?.data || []);
      } else {
        setInternalData([]);
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
    }
  };

  const getEmployeesApi = async () => {
    try {
      const response = await employees({}).unwrap();
      if (response.status === 200) {
        setEmployeeData(response?.data || []);
      } else {
        setEmployeeData([]);
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
    }
  };

  useEffect(() => {
    if (valueTabs === 0) {
      getMemberReports();
    } else if (valueTabs === 1) {
      getBookingReports();
    } else if (valueTabs === 2) {
      getCancellationReports();
    }
  }, [page, debouncedSearchTerm, valueTabs]);

  useEffect(() => {
    if (type === "bookingsRevenue") {
      setValueTabs(1);
    }
  }, []);

  useEffect(() => {
    getInterestApi();
    getExpertiseApi();
    getDietaryApi();
    getUsersApi();
    getCategoryApi();
    getInternalProcessApi();
    getEmployeesApi();
  }, []);

  return (
    <MainContainer>
      <Loader isLoad={loading} />
      <div className="main_title d_flex">
        <div className="left_s">
          <h1>Manage Analytics</h1>
        </div>
        <div className="right_s">
          <Button
            className="btn btn_primary"
            onClick={() => {
              if (valueTabs === 0) {
                exportMemberReportsApi();
              } else if (valueTabs === 1) {
                exportBookingReportsApi();
              }
            }}
          >
            <DownloadIcon /> Export
          </Button>
        </div>
      </div>
      <Box className="custom_tabs1" sx={{ width: "100%" }}>
        <Tabs
          value={valueTabs}
          onChange={handleChangeTabs}
          aria-label="basic tabs example"
          className="custom_tabs_links"
        >
          <Tab label="Member Reports" {...a11yProps(0)} />
          <Tab label="Booking Reports" {...a11yProps(1)} />
          <Tab label="Cancellation Reports" {...a11yProps(1)} />
        </Tabs>
      </Box>
      <CustomTabPanel value={valueTabs} index={0}>
        <div className="main_title d_flex mt_30">
          <div className="left_s">
            <SearchBar
              searchTerm={searchTerm}
              placeholder="Search...."
              setDebouncedSearchTerm={setDebouncedSearchTerm}
              value={searchTerm}
              onCross={() => setSearchTerm("")}
              onChange={(val: any) => {
                if (isValidInput(val.target.value)) {
                  setSearchTerm(val.target.value);
                }
              }}
            />
          </div>
          <div className="right_s">
            <MemberFilter
              handleSubmit={getMemberReports}
              startDate={memberFilters.startDate}
              endDate={memberFilters.endDate}
              setStartDate={(date: Dayjs | null) =>
                handleFilterChange("startDate", date)
              }
              setEndDate={(date: Dayjs | null) =>
                handleFilterChange("endDate", date)
              }
              membershipType={memberFilters.membershipType}
              setMembershipType={(value: string) =>
                handleFilterChange("membershipType", value)
              }
              membership={memberFilters.membership}
              setMembership={(value: string) =>
                handleFilterChange("membership", value)
              }
              subscriptionType={memberFilters.subscriptionType}
              setSubscriptionType={(value: string) =>
                handleFilterChange("subscriptionType", value)
              }
              gender={memberFilters.gender}
              setGender={(value: string) => handleFilterChange("gender", value)}
              subscriptionStartDate={memberFilters.subscriptionStartDate}
              setSubscriptionStartDate={(date: Dayjs | null) =>
                handleFilterChange("subscriptionStartDate", date)
              }
              expiryDate={memberFilters.expiryDate}
              setExpiryDate={(date: Dayjs | null) =>
                handleFilterChange("expiryDate", date)
              }
              interests={interests}
              expertise={expertise}
              dietary={dietary}
              selectedExpertise={memberFilters.expertise}
              setSelectedExpertise={(value: string[]) =>
                handleFilterChange("expertise", value)
              }
              selectedDietary={memberFilters.dietary}
              setSelectedDietary={(value: string[]) =>
                handleFilterChange("dietary", value)
              }
              selectedInterests={memberFilters.interests}
              setSelectedInterests={(value: string[]) =>
                handleFilterChange("interests", value)
              }
              onlyLoggedIn={memberFilters.onlyLoggedIn}
              setOnlyLoggedIn={(value: boolean) =>
                handleFilterChange("onlyLoggedIn", value)
              }
              notCreatedOrder={memberFilters.notCreatedOrder}
              setNotCreatedOrder={(value: boolean) =>
                handleFilterChange("notCreatedOrder", value)
              }
              activeMembersDays={memberFilters.activeMembersDays}
              setActiveMembersDays={(value: boolean) =>
                handleFilterChange("activeMembersDays", value)
              }
              inactiveMembers={memberFilters.inactiveMembers}
              setInactiveMembers={(value: boolean) =>
                handleFilterChange("inactiveMembers", value)
              }
              newSignupMembers={memberFilters.newSignupMembers}
              setNewSignupMembers={(value: boolean) =>
                handleFilterChange("newSignupMembers", value)
              }
              expiringInDays={memberFilters.expiringInDays}
              setExpiringInDays={(value: boolean) =>
                handleFilterChange("expiringInDays", value)
              }
              minAge={memberFilters.minAge}
              setMinAge={(value: number) => handleFilterChange("minAge", value)}
              maxAge={memberFilters.maxAge}
              setMaxAge={(value: number) => handleFilterChange("maxAge", value)}
              handleClearFilters={handleClearAll}
            />
          </div>
        </div>
        <div className="cards table_cards mt_20">
          <div className="table_container">
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <thead
                style={{
                  backgroundColor: "#C19857",
                  color: "#fff",
                  textAlign: "left",
                }}
              >
                <tr>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Membership Type</th>
                  <th>Membership Status</th>
                  <th>Payment Status</th>
                  <th>Created Date</th>
                </tr>
              </thead>
              <tbody>
                {memberData?.length > 0 ? (
                  memberData?.map((row, index) => (
                    <tr key={index}>
                      <td
                        style={{ cursor: "pointer" }}
                        onClick={() =>
                          navigate(`/manage-customers/detail/${row?.id}`, {
                            state: {
                              status:
                                row?.userStatus === USER_STATUS.Approved
                                  ? "APPROVED"
                                  : row?.userStatus === USER_STATUS.Rejected
                                    ? "REJECTED"
                                    : row?.userStatus === USER_STATUS.Expired
                                      ? "EXPIRED"
                                      : row?.userStatus ===
                                          USER_STATUS.Cancelled
                                        ? "CANCELLED"
                                        : "PENDING",
                              memberType: row?.membershipType,
                              subTab: valueTabs,
                              comingFrom: "reports",
                            },
                          })
                        }
                      >
                        {row?.name || "-"}
                      </td>
                      <td>{row?.email || "-"}</td>
                      <td>{row?.membershipType || "-"}</td>
                      <td>{row?.memberShip || "-"}</td>
                      <td>{row?.paymentStatus || "-"}</td>
                      <td>
                        {row?.createdAt
                          ? formatDubaiDateTime(row?.createdAt)
                          : "-"}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td
                      style={{ textAlign: "center", padding: "20px" }}
                      colSpan={6}
                    >
                      No Data Found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
        {memberData?.length ? (
          <CustomPagination
            currentPage={page - 1}
            totalPages={Math.ceil(count / 10)}
            count={count}
            pageSize={10}
            onPageChange={(page) => setPage(page + 1)}
          />
        ) : null}
      </CustomTabPanel>
      <CustomTabPanel value={valueTabs} index={1}>
        <div className="stats_boxes gap_m mt_20">
          <MetricCard
            title="Total Booking Revenue"
            value={`AED ${formatAEDNumber(totalAmount) || 0}`}
            subtext={`${trend === TREND.INCREASE ? "↑" : "↓"} ${percentChange || 0}% from last month`}
          />
        </div>
        <div className="main_title d_flex mt_30">
          <div className="left_s">
            <SearchBar
              searchTerm={searchTerm}
              placeholder="Search...."
              setDebouncedSearchTerm={setDebouncedSearchTerm}
              value={searchTerm}
              onCross={() => setSearchTerm("")}
              onChange={(val: any) => {
                if (isValidInput(val.target.value)) {
                  setSearchTerm(val.target.value);
                }
              }}
            />
          </div>
          <div className="right_s">
            <BookingFilters
              startDate={bookingFilters.startRange}
              endDate={bookingFilters.endRange}
              setStartDate={(date) =>
                handleFilterChangeBooking("startRange", date)
              }
              setEndDate={(date) => handleFilterChangeBooking("endRange", date)}
              bookingDateFrom={bookingFilters.bookingDateFrom}
              setBookingDateFrom={(value) =>
                handleFilterChangeBooking("bookingDateFrom", value)
              }
              selectedUsers={bookingFilters.userId}
              setSelectedUsers={(value) =>
                handleFilterChangeBooking("userId", value)
              }
              memberShipType={bookingFilters.memberShipType}
              setMemberShipType={(value) =>
                handleFilterChangeBooking("memberShipType", value)
              }
              selectedCategory={bookingFilters.categoryId}
              setSelectedCategory={(value) =>
                handleFilterChangeBooking("categoryId", value)
              }
              internalData={internalData}
              bookingStatus={bookingFilters.bookingStatus}
              setBookingStatus={(value) =>
                handleFilterChangeBooking("bookingStatus", value)
              }
              selectedEmployee={bookingFilters.employeeId}
              setSelectedEmployee={(value) =>
                handleFilterChangeBooking("employeeId", value)
              }
              numberOfGuests={bookingFilters.numberofGuest}
              setNumberOfGuests={(value) =>
                handleFilterChangeBooking("numberofGuest", value)
              }
              bookingNumberofDays={bookingFilters.bookingNumberofDays}
              setBookingNumberofDays={(value) =>
                handleFilterChangeBooking("bookingNumberofDays", value)
              }
              isTodayBooking={bookingFilters.isTodayBooking}
              setIsTodayBooking={(value) =>
                handleFilterChangeBooking("isTodayBooking", value)
              }
              category={categoryData}
              users={users}
              employeeData={employeeData}
              handleSubmit={getBookingReports}
              handleClearFilters={handleClearAllBookingFilter}
            />
          </div>
        </div>
        <div className="cards table_cards mt_20">
          <div className="table_container">
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <thead
                style={{
                  backgroundColor: "#C19857",
                  color: "#fff",
                  textAlign: "left",
                }}
              >
                <tr>
                  <th>Booking ID</th>
                  <th>Client Detail</th>
                  <th>Offer Name</th>
                  <th>Booking Time</th>
                  <th>Guests</th>
                  <th>Category</th>
                  <th>Employee Name</th>
                  <th>Amount</th>
                </tr>
              </thead>

              <tbody>
                {bookingData?.map((row, index) => (
                  <tr
                    key={index}
                    style={{ color: "#fff", borderBottom: "1px solid #444" }}
                  >
                    <td
                      className="cursor_p"
                      onClick={() =>
                        navigate(
                          `/manage-booking-resvp/booking-detail/${row?.guidBookingId}`,
                          {}
                        )
                      }
                    >
                      {row?.bookingId || "-"}
                    </td>
                    <td>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                          flexDirection: "column",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                          }}
                        >
                          <span style={{ fontWeight: "bold" }}>
                            {row?.clientDetail?.name || "-"}
                          </span>
                        </div>
                        <div>{`${row?.clientDetail?.phoneNumber?.countryCode ? `+${row?.clientDetail?.phoneNumber?.countryCode}` : ""} ${row?.clientDetail?.phoneNumber?.phone || "-"}`}</div>
                      </div>
                    </td>
                    <td
                      // onClick={() =>
                      //   navigate("/manage-booking-resvp/booking-detail")
                      // }
                      className="cursor_p"
                    >
                      {row?.offerTitle || "-"}
                    </td>
                    <td>
                      {row?.bookingDate
                        ? formatDubaiDateTime(row?.bookingDate)
                        : "-"}
                    </td>
                    <td>{row?.totalNumberofGuest || "-"}</td>
                    <td>{row?.categoryName || "-"}</td>
                    <td
                      className="cursor_p"
                      onClick={() => navigate("/manage-customers/detail")}
                    >
                      {row?.employeesDetails?.employeeName || "-"}
                    </td>
                    <td>
                      AED{" "}
                      {row?.totalParticipantAmount
                        ? formatAEDNumber(row?.totalParticipantAmount)
                        : "0"}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
        {bookingData?.length ? (
          <CustomPagination
            currentPage={page - 1}
            totalPages={Math.ceil(count / 10)}
            count={count}
            pageSize={10}
            onPageChange={(page) => setPage(page + 1)}
          />
        ) : null}
      </CustomTabPanel>
      <CustomTabPanel value={valueTabs} index={2}>
        <div className="main_title d_flex mt_30">
          <div className="left_s">
            <SearchBar
              searchTerm={searchTerm}
              placeholder="Search...."
              setDebouncedSearchTerm={setDebouncedSearchTerm}
              value={searchTerm}
              onCross={() => setSearchTerm("")}
              onChange={(val: any) => {
                if (isValidInput(val.target.value)) {
                  setSearchTerm(val.target.value);
                }
              }}
            />
          </div>
        </div>{" "}
        <div className="cards table_cards mt_20">
          <div className="table_container">
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <thead
                style={{
                  backgroundColor: "#C19857",
                  color: "#fff",
                  textAlign: "left",
                }}
              >
                <tr>
                  <th>Booking ID</th>
                  <th>Client Detail</th>
                  <th>Offer Name</th>
                  <th>Booking Time</th>
                  <th>Guests</th>
                  <th>Category</th>
                  <th>Employee Name</th>
                  <th>Cancellation Reason</th>
                </tr>
              </thead>

              <tbody>
                {rows1.map((row, index) => (
                  <tr
                    key={index}
                    style={{ color: "#fff", borderBottom: "1px solid #444" }}
                  >
                    <td>{row.bookingId}</td>
                    <td>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                          flexDirection: "column",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                          }}
                        >
                          <span style={{ fontWeight: "bold" }}>{row.name}</span>
                        </div>
                        <div>{row.phone}</div>
                      </div>
                    </td>
                    <td
                      // onClick={() =>
                      //   navigate("/manage-booking-resvp/booking-detail")
                      // }
                      className="cursor_p"
                    >
                      {row.offerName}
                    </td>
                    <td>{row.bookingTime}</td>
                    <td>{row.guests}</td>
                    <td>{row.category}</td>
                    <td
                      className="cursor_p"
                      // onClick={() => navigate("/manage-customers/detail")}
                    >
                      {row.employeeName}
                    </td>
                    <td>{row.reason}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </CustomTabPanel>
    </MainContainer>
  );
};

export default ManageAnalytics;
